'use client';
import { PAGE_QUERYResult } from '@/sanity.types';
import React, { useState } from 'react';
import './splitCarousel.scss';
import { CarouselDisplay } from './components/carouselDisplay';
import { Button, Col, Container, Row } from 'react-bootstrap';
import CarouselBullets from './components/carouselDisplay/carouselBullets';

type SplitCarouselProps = Extract<
  NonNullable<NonNullable<PAGE_QUERYResult>['content']>[number],
  { _type: 'splitCarousel' }
>;
export const SplitCarousel = ({
  slides,
  header,
  layout,
  ctaButton,
  _key,
  frame,
}: SplitCarouselProps) => {
  const bulletItems =
    slides?.map((slide) => ({
      signupText: slide?.linkText || '/n_images/default-blog.jpg',
    })) || [];

  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <section id={`_${_key}`} className="splitCarousel-Container">
      <Container>
        <Row
          className={`splitCarousel-content-wrap ${
            layout === 'left' ? 'carousel-left' : 'carousel-right'
          }`}
        >
          <Col md={5} className="carousel-content">
            <h2>{header}</h2>
            <CarouselBullets
              signupItems={bulletItems}
              activeIndex={activeIndex}
              onBulletClick={setActiveIndex}
            />
            {ctaButton?.text && (
              <Button
                variant="primary"
                href={ctaButton?.link}
                style={{
                  backgroundColor: ctaButton?.color?.value,
                }}
              >
                {ctaButton?.text}
              </Button>
            )}
          </Col>
          <Col md={7} className="carousel-image">
            <CarouselDisplay
              slides={slides}
              activeIndex={activeIndex}
              onSelect={setActiveIndex}
              frame={frame || false}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
